let language = {
    // 
    STANDARD_ORDER_WAITING_PAYMENT_TIME_TIP: "(You can pay this order in {{paymentWaitingTime}} minutes after you create this order, or else it will be cancel after {{paymentWaitingTime}} minutes.)",

    // 
    STANDARD_ORDER_PAYMENT_TIME_COUNT_TIP1: "You can pay this order in",
    STANDARD_ORDER_PAYMENT_TIME_COUNT_TIP2: "second.",
    STANDARD_ORDER_PAYMENT_TIME_COUNT_TIP3: "minutes.",

    // 
    standard_order_payment_fail_tip_title: "Payment failed",
    standard_order_payment_fail_tip_content: "This order has not been paid within 30 minutes or has been cancelled.",

    // 
    standard_order_cancel_order_tip_title: "Order cancelled successfully!",
    standard_order_cancel_order_tip_content: "Jump to the order list page.",

    STANDARD_ORDER_WAITING_PAYMENT_FAILED_DES1: "Order payment failed, You can go to",
    STANDARD_ORDER_WAITING_PAYMENT_FAILED_DES2: "to check the reason."
};

export { language }